import * as React from 'react';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import EstimationPeriodModel from '../../domain/EstimationPeriod';
import { connect } from 'react-redux';
import Edit from '../common/Edit';
import EstimationPeriodUpdateRequested from '../../application/admin/events/EstimationPeriodUpdateRequested';
import Months from './Months';
import { ChangeEvent } from 'react';
import { Month, monthByNumber } from './getEstimationMonths';
import Dropdown from '../common/Dropdown';
import './EstimationPeriod.css';

interface Props {
    estimationPeriod: EstimationPeriodModel;
}

interface State {
    editedEstimationPeriod: EstimationPeriodModel;
    isEdited: boolean;
}

class EstimationPeriod extends React.PureComponent<Props & DispatchProps, State> {
    private optionYes = 'yes';
    private optionNo = 'no';

    constructor(props: Props & DispatchProps) {
        super(props);
        this.state = {
            editedEstimationPeriod: {
                ...props.estimationPeriod
            },
            isEdited: false
        };
    }

    public render(): JSX.Element {
        return (
            <div className="estimation">
                <div className="estimation-period card">
                    {this.renderData()}
                    <div className="estimation-buttons">
                        <Edit
                            onEdit={this.editRequested}
                            onCancel={this.cancelRequested}
                            onSave={this.saveRequested}
                            isEdited={this.state.isEdited}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private renderData = (): JSX.Element => {
        if (!this.state.isEdited) {
            return (
                <div className="estimation-period-details">
                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label">Is open:</span>
                        <span className="estimation-period-details-value">
                            {this.props.estimationPeriod.isOpen ? this.optionYes : this.optionNo}
                        </span>
                    </div>
                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label" />
                        <span className="estimation-period-details-value">
                            {this.props.estimationPeriod.months.map((month: Month, index: number) => (
                                <span key={month.month} className="estimation-period-details-value-col">
                                    Month {index + 1}
                                </span>
                            ))}
                        </span>
                    </div>
                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label">Estimation quarter:</span>
                        <span className="estimation-period-details-value">
                            {this.props.estimationPeriod.months.map((month: Month) => (
                                <span key={month.month} className="estimation-period-details-value-col">
                                    {monthByNumber[month.month] + '/' + month.year}
                                </span>
                            ))}
                        </span>
                    </div>
                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label">Open message:</span>
                        <span className="estimation-period-details-value">{this.props.estimationPeriod.openMessage}</span>
                    </div>
                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label">Close message:</span>
                        <span className="estimation-period-details-value">{this.props.estimationPeriod.closeMessage}</span>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="estimation-period-details">
                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label">Is open: {this.props.estimationPeriod.isOpen} </span>
                        <span className="estimation-period-details-value">
                            <Dropdown
                                placeholder="is open"
                                options={[this.optionYes, this.optionNo]}
                                selectedOption={this.state.editedEstimationPeriod.isOpen ? this.optionYes : this.optionNo}
                                onChange={this.statusChanged}
                                class="admin-select"
                                color="gray"
                            />
                        </span>
                    </div>

                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label" />
                        <span className="estimation-period-details-value">
                            {this.props.estimationPeriod.months.map((month: Month, index: number) => (
                                <span key={month.month} className="estimation-period-details-value-col">
                                    Month {index + 1}
                                </span>
                            ))}
                        </span>
                    </div>
                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label">Estimation quarter:</span>
                        <span className="estimation-period-details-value estimation-period-details-months">
                            <Months monthSelected={this.monthSelected} months={this.state.editedEstimationPeriod.months} />
                        </span>
                    </div>
                    {/*<Months monthSelected={this.monthSelected} months={this.state.editedEstimationPeriod.months}/>*/}
                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label">Open message:</span>
                        <span className="estimation-period-details-value">
                            <input
                                value={this.state.editedEstimationPeriod.openMessage}
                                placeholder="open message"
                                onChange={this.openMessageChanged}
                            />
                        </span>
                    </div>

                    <div className="estimation-period-details-row">
                        <span className="estimation-period-details-label">Close message:</span>
                        <span className="estimation-period-details-value">
                            <input
                                value={this.state.editedEstimationPeriod.closeMessage}
                                placeholder="close message"
                                onChange={this.closeMessageChanged}
                            />
                        </span>
                    </div>
                </div>
            );
        }
    };

    private openMessageChanged = (e: ChangeEvent<HTMLInputElement>): void =>
        this.setState({
            editedEstimationPeriod: {
                ...this.state.editedEstimationPeriod,
                openMessage: e.currentTarget.value
            }
        });

    private closeMessageChanged = (e: ChangeEvent<HTMLInputElement>): void =>
        this.setState({
            editedEstimationPeriod: {
                ...this.state.editedEstimationPeriod,
                closeMessage: e.currentTarget.value
            }
        });

    private monthSelected = (months: Month[]): void => {
        this.setState({
            editedEstimationPeriod: {
                ...this.state.editedEstimationPeriod,
                months
            }
        });
    };

    private editRequested = (): void =>
        this.setState({
            isEdited: true,
            editedEstimationPeriod: {
                ...this.props.estimationPeriod
            }
        });

    private cancelRequested = (): void => this.cancelEdit();

    private cancelEdit = (): void =>
        this.setState({
            isEdited: false
        });

    private statusChanged = (isOpen: string): void =>
        this.setState({
            editedEstimationPeriod: {
                ...this.state.editedEstimationPeriod,
                isOpen: isOpen === this.optionYes
            }
        });

    private saveRequested = (): void => {
        this.cancelEdit();
        this.props.dispatch(new EstimationPeriodUpdateRequested(this.state.editedEstimationPeriod));
    };
}

export default connect(
    null,
    mapDispatchToProps
)(EstimationPeriod);



// WEBPACK FOOTER //
// ./src/view/admin/EstimationPeriod.tsx